// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"989b0964","144":"c7ae80ee","256":"91a2f0ba","305":"56ad3f4e","406":"c61d1011","626":"99800b19","778":"5cae2e31","930":"4ecd5bda","936":"25fcb9cd"}[chunkId] + ".chunk.js";
};